export default __webpack_public_path__ + "static/media/loading.f9f1dd32.webp";